import { render } from "./SquareBtn.vue?vue&type=template&id=74c46d26"
import script from "./SquareBtn.vue?vue&type=script&lang=js"
export * from "./SquareBtn.vue?vue&type=script&lang=js"

import "./SquareBtn.vue?vue&type=style&index=0&id=74c46d26&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__